module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/wx-tip.b4f27.png";